import {
  StyleCardHeader,
  StyleWrapper,
  StyleCardFooter,
  StyleLastMeetingWrapper,
} from './style'
import Skeleton from '@components/skeleton'
import Column from '@components/column'
import Row from '@components/row'
const PatientCardLoader = () => {
  return (
    <StyleWrapper>
      <StyleCardHeader>
        <Skeleton width={50} height={50} radius={25} />
        <Column rowGap={10}>
          <Skeleton width={100} height={10} radius={4} />
          <Row colGap={10}>
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
            <Skeleton width={45} height={25} radius={4} />
          </Row>
        </Column>
      </StyleCardHeader>
      <StyleCardFooter>
        <StyleLastMeetingWrapper>
          <Skeleton width={25} height={20} radius={4} />
          <Skeleton width={100} height={10} radius={4} />
        </StyleLastMeetingWrapper>
        <Skeleton width={'39%'} height={40} radius={8} />
      </StyleCardFooter>
    </StyleWrapper>
  )
}

export default PatientCardLoader
